export enum TokenExpiration {
  DAY = 60 * 60 * 24, // 24 hours in seconds
  TEST_EXP = 60, // 1 minute in seconds
}
